// import list from 'page/consultText/list.vue'
const list = () =>
  import(/* webpackChunkName: "consultTextlist" */ 'page/consultText/list.vue')
const routes = [
  {
    path: '/consult-text/list',
    component: list,
    meta: {
      pageName: '文字倾诉专题页',
      business: '文字咨询'
    }
  }
]

export default routes
